import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Subscription } from 'rxjs';
import { AvatarsService } from '../../services/avatars.service';

export type AvatarSize = 'xs' | 'sm' | 'md' | 'lg';

@Component({
  selector: 'app-avatar-circle',
  templateUrl: './avatar-circle.component.html',
  styleUrls: ['./avatar-circle.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [CommonModule],
})
export class AvatarCircleComponent implements OnInit, OnChanges, OnDestroy {
  @Input() ebeId: string = '';
  @Input() size: AvatarSize = 'md';
  @Input() sizePx?: number;
  @Input() alt?: string;
  @Output() avatarClick = new EventEmitter<void>();

  miniUrl: string | null = null;
  readonly fallbackSrc = 'assets/user.png';

  private miniSubscription?: Subscription;

  constructor(private avatarsService: AvatarsService, private cdr: ChangeDetectorRef) {}

  ngOnInit(): void {
    this.subscribeToMini();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['ebeId'] && !changes['ebeId'].firstChange) {
      this.subscribeToMini();
    }
  }

  ngOnDestroy(): void {
    this.miniSubscription?.unsubscribe();
  }

  get px(): number {
    if (this.sizePx) return this.sizePx;
    switch (this.size) {
      case 'xs': return 24;
      case 'sm': return 32;
      case 'md': return 48;
      case 'lg': return 96;
      default: return 48;
    }
  }

  get ariaLabel(): string {
    return this.alt || 'Profilbild';
  }

  onAvatarClick(): void {
    this.avatarClick.emit();
  }

  private subscribeToMini(): void {
    this.miniSubscription?.unsubscribe();
    this.miniUrl = null;
    this.cdr.markForCheck();

    if (!this.ebeId) return;

    this.miniSubscription = this.avatarsService.mini$(this.ebeId).subscribe(url => {
      this.miniUrl = url;
      this.cdr.markForCheck();
    });
  }
}
